import { IEstimationPricingOptionModel } from './estimation-pricing-option.model';
import { IEstimationTaxModel } from './estimation-tax.model';

export class Estimation {
  public basePrice: number = 0;
  public pricingOptions?: IEstimationPricingOptionModel[] = [];
  public gazoleTaxRate: number = 0;
  public gazoleTaxAmount: number = 0;
  public taxes?: IEstimationTaxModel[] = [];
  public insurance: number = 0;
  public priceHT: number = 0;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  public vatRate(): number {
    return 20; //TODO: En FR la TVA est a 20%
  }

  public vat(): number {
    return (this.priceHT * this.vatRate()) / 100;
  }

  public ttc(): number {
    return this.priceHT + this.vat();
  }
}
